import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import * as $ from 'jquery';

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class SuccessDialog extends Component {
    componentDidMount() {
        $('#btnSuccess').click()
        $('#modalSuccess').on('hidden.bs.modal', () => {
            // console.log('El modal se cerró/dismiss');
            // Puedes realizar acciones adicionales después de que el modal se cierra
            // this.props.history
            this.props.history.replace(`${URI_VENTA_EN_LINEA}/agradecimiento`);
        });
    }
  render() {
    const { t } = this.props;
    return(
      <div>
        <button
          className="hidden"
          data-target="#modalSuccess"
          data-toggle="modal"
          id="btnSuccess"
          type="button">
        </button>
        <div className="modal fade" id="modalSuccess" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4>{t('dashboard.room_payment.heading_success')}</h4>
                <p>
                  <Trans i18nKey="dashboard.room_payment.success" name={this.props.centerName}>
                    Has hecho una reservación exitosa en {{name: this.props.centerName}}. Hemos enviado todos los detalles de la reserva a tu correo electrónico
                  </Trans>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => this.props.history.replace(`${URI_VENTA_EN_LINEA}/agradecimiento`)}
                  type="button">
                  {t('dashboard.room_payment.btn_success')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(SuccessDialog);



// WEBPACK FOOTER //
// ./src/components/SuccessDialogPayment/index.jsx